import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../context/auth-context';
import { useSiteConfig } from '../../../context/site-configs-context';
import { getEnvironmentVariable } from '../../../utils';
import './SideMenuSkin1.scss';

const platformURL = getEnvironmentVariable('REACT_APP_PLATFORM_URL');
const LOGIN_URL = `${platformURL}/login`;
const REGISTRATION_URL = `${platformURL}/register`;

interface ExternalLink {
    name: string;
    value: string;
    show: boolean;
}

interface Props {
    externalLinks?: ExternalLink[];
}

const SideMenuSkin1: React.FC<Props> = ({
    externalLinks = [],
}) => {

    const navigate = useNavigate();
    const { isAuthenticated, userInfo, logout } = useAuth();
    const { logo } = useSiteConfig();

    const handleTermsClick = () => {
        navigate('/terms-of-use');
    };

    const loginUrl = `${LOGIN_URL}?callback=${window.location.href}`;

    return (
        <div className="side-menu-skin1">

            <div className="menu-logo" onClick={() => navigate('/')}>
                <img src={logo} width={150} alt="logo"/>
            </div>

            <div className="menu-links">
                {externalLinks
                .filter(link => link.show)
                .map((link, index) => (
                    <a
                        key={index}
                        href={link.value}
                        className="menu-link"
                        target="_blank"
                        rel="noreferrer"
                    >
                        {link.name}
                    </a>
                ))}
            </div>

            <div className="menu-bottom">
                <button
                    className="menu-terms-btn"
                    onClick={handleTermsClick}
                >
                    Terms Of Use
                </button>
                {isAuthenticated && userInfo && (
                    <>
                        <div className="username">
                            {userInfo.username}
                        </div>

                        <button
                            className="logout-btn"
                            onClick={logout}
                        >
                            Log Out
                            <svg className="logout-menu-svg" width="35" height="35" viewBox="0 0 35 35" fill="none"
                                 xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M23.3333 24.7917L30.625 17.5M30.625 17.5L23.3333 10.2083M30.625 17.5H13.125M13.125 4.375H11.375C8.92477 4.375 7.69965 4.375 6.76379 4.85185C5.94058 5.27129 5.27129 5.94058 4.85185 6.76379C4.375 7.69965 4.375 8.92477 4.375 11.375V23.625C4.375 26.0753 4.375 27.3003 4.85185 28.2362C5.27129 29.0595 5.94058 29.7287 6.76379 30.1481C7.69965 30.625 8.92477 30.625 11.375 30.625H13.125"
                                    stroke="#CD0000" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>

                        </button>
                    </>
                )}
                {!userInfo && (
                    <>
                        <Link className="menu_register" to={REGISTRATION_URL}> Register </Link>
                        <Link className="menu_login" to={loginUrl}> Login </Link>
                    </>
                )}
            </div>
        </div>
    );
};

export default SideMenuSkin1;